import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApiService } from "src/app/services/api.service";
import { SearchData } from "src/app/services/searchData";
import { WidgetModule } from '../../../widget/widget.module';
import { BussinessPostComponent } from '../../../components/bussiness-post/bussiness-post.component';

@Component({
  selector: "app-team-home-page",
  standalone: true,
  imports: [CommonModule, WidgetModule, BussinessPostComponent],
  templateUrl: "./team-home-page.component.html",
  styleUrls: ["./team-home-page.component.scss"],
})
export class TeamHomePageComponent implements OnInit {
  commonVariables: any = {};
  constructor(private api: ApiService, private searchData: SearchData) {}

  ngOnInit() {

  }
}

